import axios from 'axios'
import { ElMessage } from 'element-plus'
import { BASE_URL} from '../../src/service/request4/config'
//文档流导出excel
export function exportMethod(url,dowlonadName,data) {
    axios({
        method: "post",
        url: `${BASE_URL}${url}`,
        data,
        // headers:{
        //     'Authorization' : `Bearer ${getToken()}`
        // },
        responseType: 'blob'
    }).then((res) => {
        const link = document.createElement('a')
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        let temName = dowlonadName+'.xls'
        link.download = temName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }).catch(error => {
        ElMessage({
            message: error.errorMessage || 'Error',
            type: 'error',
            duration: 5 * 1000
        })
    })
}